import React, { forwardRef, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { useForm } from "react-hook-form";

import { DataTable, ProjectCard, PDFViewCard } from '../../Components';
import { IdentifyTypeName } from '../../Utils/Prefix';
import { DateThaiFormat, GradeLevelName,GetAPIURL, GetAuthorization, } from '../../Utils/Function';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../App.css';

const ProjectView = forwardRef((props, ref) => {
    const { register, getValues, setValue } = useForm();
    const RedirectTo = useNavigate()
    const [_ProjectGroupList, setProjectGroupList] = useState([]);
    const _PDFViewCard = useRef();
    const _ProjectView = useRef();
    const _ProjectCard = useRef();
    const [_GradeLevelList, setGradeLevelList] = useState([1, 2]);
    useEffect(() => {
        (async () => {
            _LoadProjectGroup();
        })();

        return () => { }
    }, []);
    const _LoadProjectGroup = async () => {
        setProjectGroupList([]);
        API({ method: "get", url: "/Staff/Project/Group" }).then(res => {
            setProjectGroupList(res.data);
        });

    }
    const _configs = {
        "order": [[4, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax = {
        'url': '/Staff/Project/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.Status = getValues('Status');
            d.GradeLevel = getValues('GradeLevel');
            d.ProjectGroupID = getValues('ProjectGroupID');
        }
    };

    const _Buttons = (d, r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => { _ProjectCard.current?.Show(d) }}>Info</button>
            <a className="btn btn-primary text-white" title="รายงานสรุป" href={GetAPIURL() + '/Excel/' + d + '/' + GetAuthorization() + '/Summary'} target='_blank' >รายงานสรุป</a>
            <a className="btn btn-primary text-white" title="ห้องสอบ" href={GetAPIURL() + '/Excel/' + d + '/' + GetAuthorization() + '/Room'} target='_blank' >ห้องสอบ</a>
        </div>
    )
    const _column = [
        { data: "ProjectName", name: "ProjectName", autoWidth: true },
        { data: "ProjectGroupName", name: "ProjectGroup", autoWidth: true },
        { data: "YearEDU", name: "YearEDU", autoWidth: true },
        {
            data: "GradeLevel", name: "GradeLevel", autoWidth: true, render(data) {
                return GradeLevelName(data);
            }
        },
        { data: "Sorting", name: "Sorting", autoWidth: true },
        {
            data: "ProjectID", name: "ProjectID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData, rowData) => createRoot(td).render(_Buttons(cellData, rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    const _Update = async () => {
        _ProjectView.current?.load()

    }
    const _ADD = async () => {
        _ProjectCard.current?.Show(null);
    }
    return (
        <>
            <React.Fragment>
                <div className='row'>
                    <div className='col-lg-12 mt-2'>
                        <div className='row mb-4'>
                            <div className='col-12'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <div className='card-title fs-5 fw-semibold'>
                                            <div className='row'>
                                                <div className='col-lg-8'><h4 className='text-start mt-2'>รายการโครงการ</h4></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row mt-2 mb-2 justify-content-end'>
                                            <div className='col-lg-3'>
                                                <select className='form-control' {...register("ProjectGroupID", { required: false })} defaultValue={0}>
                                                    <option value={0}>แสดงทั้งหมด</option>
                                                    {_ProjectGroupList.map((v, i) => (
                                                        <option value={v.projectGroupId} key={i}>{v.projectGroupName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='col-lg-2'>
                                                <select className='form-control' {...register("GradeLevel", { required: false })} defaultValue={0}>
                                                    <option value={0}>แสดงทั้งหมด</option>
                                                    {_GradeLevelList.map((v, i) => (
                                                        <option value={v} key={i}>{GradeLevelName(v)}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='col-lg-1 text-end'>
                                                <div className='btn-group'>
                                                    <button type='button' className='btn btn-info text-white' onClick={() => { _Update(); }}>ค้นหา</button>
                                                    <button type='button' className='btn btn-success text-white' onClick={() => { _ADD(); }}>เพิ่ม</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-2 mb-2'>
                                            <div className='col-12 table-responseive'>
                                                <div className='table-response'>
                                                    <table className='table' id="ProjectView">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-center textleft'>โครงการ</th>
                                                                <th className='text-center textleft'>กลุ่มโครงการ</th>
                                                                <th className='text-center textcenter'>ปีการศึกษา</th>
                                                                <th className='text-center textcenter'>ระดับชั้น</th>
                                                                <th className='text-center textcenter'>ลำดับแสดงผล</th>
                                                                <th className='text-center textcenter no-sort'>#</th>
                                                            </tr>
                                                        </thead>
                                                        <DataTable TableID={"ProjectView"} Column={_column} Configs={_configs} ref={_ProjectView} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </React.Fragment>
            <PDFViewCard ref={_PDFViewCard} />
            <ProjectCard ref={_ProjectCard} />
        </>
    )
});
export default React.memo(ProjectView)